import { Metric } from "./Metric";
import { TaskParameter } from "./TaskParameter";

export class Task {
  id?: number;
  name: string;
  description: string;
  type: string
  parameters: TaskParameter[];
  sessionId?: number;
  taskInstanceId?: number;
  taskId?: number;
  createdAt?: string;
  updatedAt?: string;
  videoUrl?: string;
  metricTypes: Number[];

  constructor() {
    this.name = "";
    this.description = "";
    this.type = "";
    this.parameters = new Array<TaskParameter>();
    this.metricTypes = []
  }
}

export class Task4Metrics {
  id?: number;
  name: string;
  description: string;
  type: string
  parameters: TaskParameter[];
  sessionId?: number;
  taskInstanceId?: number;
  taskId?: number;
  createdAt?: string;
  updatedAt?: string;
  videoUrl?: string;
  metricTypes: Metric[];

  constructor(task: Task) {
    this.id = task.id || undefined
    this.name = task.name || "";
    this.description = task.description || "";
    this.type = task.type || "";
    this.parameters = task.parameters || new Array<TaskParameter>();
    this.sessionId = task.sessionId || undefined;
    this.taskInstanceId = task.sessionId || undefined;
    this.taskId = task.id || undefined;
    this.createdAt = task.createdAt || '';
    this.updatedAt = task.updatedAt || '';
    this.videoUrl = task.videoUrl || "";
    this.metricTypes =  [];
  }
}



export interface TaskInstance {
  taskId?: number,
  start?: Date,
  end?: Date,
  taskConfigurationXml?: TaskConfigurationXml[]

}



export interface TaskConfigurationXml {
  id: number,
  name: string,
  type: string,
  description: string,
  icon: string,
  order: number,
  default_input_filename: string,
  config: any
}